module.exports = '<svg width="30" height="32" viewBox="0 0 30 32"><path d="M29.184 19.362L18 11.25V4.63c0-.566-.27-1.388-.6-1.84L15.6.342c-.33-.456-.87-.456-1.2 0l-1.8 2.45c-.33.45-.6 1.272-.6 1.838v6.62L.816 19.362c-.45.324-.816 1.046-.816 1.61v4.084c0 .564.388.794.87.516L12 20.806v7.344l-2 2.042v1.024c0 .564.448.784 1 .784h8c.552 0 1-.22 1-.786V30.19l-2-2.042v-7.344l11.13 4.766c.48.28.87.048.87-.516V20.97c0-.562-.366-1.284-.816-1.608z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/airplane-1.js
// module id = 980
// module chunks = 14